export function measureCompHeight(measures, dom, assignToCss) {
  dom.measure(target => {
    if (!target) {
      return;
    }
    measures.compHeight = target.offsetHeight;
  });
  if (assignToCss) {
    dom.mutate(target => {
      target == null || target.style.setProperty('--motion-comp-height', `${measures.compHeight}px`);
    });
  }
}
const getMasterPage = () => window.document.getElementById('masterPage');
const getWixAdsHeight = () => {
  const wixAds = window.document.getElementById('WIX_ADS');
  return wixAds ? wixAds.offsetHeight : 0;
};
const getSiteHeight = () => {
  const masterPage = getMasterPage();
  return masterPage ? masterPage.offsetHeight + getWixAdsHeight() : 0; // probably tests that don't have masterPage created
};
export function measureSiteHeight(measures, dom) {
  dom.measure(() => {
    measures.siteHeight = getSiteHeight();
  });
}
export function getScaleFromPerspectiveAndZ(z, perspective) {
  return z > perspective ? 0 : 1.0 / (1 - z / perspective);
}
//# sourceMappingURL=utils.js.map